import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
//import ReactMarkdown from 'react-markdown'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { typeFromId, getScaffoldFromLoc } from '../../utils/FlyBaseIds'
import ReportLink from '../ReportLink'
import FlyBaseSymbol from '../FlyBaseSymbol'
import BrowserLinks from '../BrowserLinks'
import UpdateFlag from '../UpdateFlag'
import ToggleAll from '../ToggleAll'
import TableItemCheckbox from '../TableItemCheckbox'
import CheckCircle from '../CheckCircle'

import { toJS } from 'mobx'

import 'react-bootstrap-table/dist/react-bootstrap-table.min.css'

// react-bootstrap-table docs - http://allenfang.github.io/react-bootstrap-table/docs.html

// Bootstrap table data formatters
function setHTML(data, item, formatExtraData, rowIdx) {
  return <span dangerouslySetInnerHTML={{ __html: data }} />
}

function lesion(data, item, formatExtraData, rowIdx) {
  let lesion = item.known_lesion === '1' ? 'yes' : 'no'
  return <span>{lesion}</span>
}

function segments(data, item, formatExtraData, rowIdx) {
  let segs = []
  if (item.deleted_segments.length)
    segs.push('<i>deleted</i>: ' + item.deleted_segments)
  if (item.duplicated_segments.length)
    segs.push('<i>duplicated:</i> ' + item.duplicated_segments)
  return segs.join('<br />')
}

function removeUnderscores(data, item, formatExtraData, rowIdx) {
  return <span>{item[formatExtraData].replace(/_/gi, ' ')}</span>
}

function imageLink(data, item, formatExtraData, rowIdx) {
  const url = `/images/FBim/${data}`
  return (
    <ReportLink id={item.id}>
      <img src={url} alt={item.id} />
    </ReportLink>
  )
}

function checkbox(data, item, formatExtraData, rowIdx) {
  return <TableItemCheckbox store={formatExtraData.store} id={item.id} />
}

function getImageDescription(data, item, formatExtraData, rowIdx) {
  const descrpt = item.caption.substring(0, item.caption.indexOf('.'))
  return <span>{descrpt}</span>
}

function reportLink(data, item, formatExtraData, rowIdx) {
  let updateFlag
  if (item.update_status) updateFlag = <UpdateFlag item={item} />
  return (
    <span>
      <ReportLink id={item.id}>
        <FlyBaseSymbol symbol={data} />
      </ReportLink>
      {updateFlag}
    </span>
  )
}
/*
function linkMIM(data, item, formatExtraData, rowIdx) {
  const acc = data ? data['accession'] : ''
  const url = `https://omim.org/entry/${acc}`
  if (data) return <a href={url}>{acc}</a>
  else return ''
}
*/
function linkOMIM(data, item, formatExtraData, rowIdx) {
  const acc = data ? data['accession'] : ''
  const url = `https://omim.org/entry/${acc}`
  if (data) return <a href={url}>{acc}</a>
  else return ''
}

function linksHGNC(data, item, itemArrayKey, rowIdx) {
  let links = []
  for (let l = 0; l < data.length; l++) {
    let hgncObj = data[l]
    let hgncURL = hgncObj.url
    let hgncDsc = hgncObj.description
    if (hgncObj) {
      if (l > 0) links.push(<span key={'hgnc_spacer' + l}>,&emsp;</span>)
      links.push(
        <a href={hgncURL} key={'hgnc' + l}>
          {hgncDsc}
        </a>
      )
    }
  }
  if (data) return <span>{links}</span>
  else return ''
}

function stockExternalLink(data, item, formatExtraData, rowIdx) {
  let collection = item.collection
  let link = item.stock_num
  if (collection.match(/bloomington/i))
    link = (
      <a href={'https://bdsc.indiana.edu/stocks/' + item.stock_num}>
        {item.stock_num}
      </a>
    )
  else if (collection.match(/Kyoto/i))
    link = (
      <a
        href={
          'https://kyotofly.kit.jp/cgi-bin/stocks/search_res_det.cgi?DG_NUM=' +
          item.stock_num
        }>
        {item.stock_num}
      </a>
    )
  else if (collection.match(/Vienna/i))
    link = (
      <a
        href={
          'http://stockcenter.vdrc.at/control/product/~product_id=' +
          item.stock_num
        }>
        {item.stock_num}
      </a>
    )
  /*
    else if( collection.match(/Carpenter/i) ) clcn = 'Carpenter';
    else if( collection.match(/Exelixis/i) )  clcn = 'Exelixis';  // can't do direct links to Exelixis
    else if( collection.match(/FlyORF/i) )    clcn = 'FlyORF';
    else if( collection.match(/Garcia/i) )    clcn = 'GB';
    else if( collection.match(/Nusslein/i) )  clcn = 'NV';
    else if( collection.match(/Diego/i) )     clcn = 'DSSC';
    */
  return <span>{link}</span>
}

function showRelated(data, item, targetDataClass, rowIdx) {
  const url = `/hitlist/${item.id}/to/${targetDataClass}`
  return <a href={url}>{data}</a>
}

function expandArray(data, item, itemArrayKey, rowIdx) {
  if (item[itemArrayKey]) {
    return item[itemArrayKey].join('; ')
  }
}

function reportLinkHash(data, item, formatExtraData, rowIdx) {
  let list = []
  if (!data) return ''
  for (let k of Object.keys(data)) {
    let sym = data[k]
    if (formatExtraData === 'true') sym = sym.replace(/_/gi, ' ')
    if (k.match(/^[FB|SO|DO|MI|GO]/))
      list.push(
        <ReportLink key={k} id={k}>
          <FlyBaseSymbol symbol={sym} />
        </ReportLink>,
        <br key={k + 1} />
      )
  }
  return (
    <div
      key={'reportLinkHash' + Math.random()}
      style={{
        maxHeight: 80,
        overflowX: 'hidden',
        overflowY: 'auto',
        marginRight: -5,
      }}>
      {list}
    </div>
  )
}

function reportLinkArray(data, item, formatExtraData, rowIdx) {
  let list = []
  if (!data) return ''
  for( let k=0; k<data.length; k++ ) {
    let linkObj = data[k]
    let sym = linkObj.symbol
    if (formatExtraData === 'true') linkObj = linkObj.replace(/_/gi, ' ')
      list.push(
        <ReportLink key={linkObj.id} id={linkObj.id}>
          <FlyBaseSymbol symbol={sym} />
        </ReportLink>,
        <span>&emsp;</span>
      )
  }
  return (
    <div
      key={'reportLinkHash' + Math.random()}
      style={{
        maxHeight: 80,
        overflowX: 'hidden',
        overflowY: 'auto',
        marginRight: -5,
      }}>
      {list}
    </div>
  )
}

function reportLinkHash2Text(data, item, delimiter, rowIdx) {
  let list = []
  for (let k of Object.keys(data)) {
    if (k.match(/^[FB|SO|DO|MI|GO]/)) {
      // console.debug(k+": "+data[k]);
      list.push(data[k]) // .replace(/_/g,' ')
    }
  }
  let listtext = list.join(', ')
  return (
    <ReportLink id={item.id}>
      <span>{listtext}</span>
    </ReportLink>
  )
}

function nameIDList(data, item, formatExtraData, rowIdx) {
  let lst = []
  for (let k = 0; k < data.length; k++) {
    let gngp = data[k]
    if (gngp) {
      if (k > 0) lst.push(<span>;&emsp;</span>)
      lst.push(
        <ReportLink key={'link_' + gngp.id} id={gngp.id}>
          {gngp.name}
        </ReportLink>
      )
    }
  }
  return (
    <div
      key={'nameIDList' + Math.random()}
      style={{
        maxHeight: 80,
        overflowX: 'hidden',
        overflowY: 'auto',
        marginRight: -5,
      }}>
      {lst}
    </div>
  )
}
/*
function domainList( data, item, itemArrayKey, rowIdx ) {
  let domainsArr = item[itemArrayKey].slice(0);  // make a copy
  domainsArr.sort( function(a,b) { return a.start - b.start; } );
  let list = [];
  for( let i=0; i<domainsArr.length; i++ ) {
    let domain = domainsArr[i];
   // console.debug(domain.abbrev+': '+domain.start);
    if( i>0 ) list.push(<span key={i+"comma"}>, </span>);
    list.push(<span key={i} style={{whiteSpace:'nowrap'}}>{domain.abbrev} {'('+domain.start+'-'+domain.end+')'}</span>);
  }
  return(<div>{list}</div>);
}
*/
function domainListUnique(data, item, itemArrayKey, rowIdx) {
  let domainsArr = item[itemArrayKey].slice(0) // make a copy
  domainsArr.sort(function (a, b) {
    return a.start - b.start
  })
  let hash = {}
  for (let i = 0; i < domainsArr.length; i++) {
    let domain = domainsArr[i]
    if (hash.hasOwnProperty(domain.abbrev)) hash[domain.abbrev]++
    else hash[domain.abbrev] = 1
  }
  // console.debug(hash);
  let domains = []
  let keys = Object.keys(hash)
  for (let i = 0; i < keys.length; i++) {
    let key = keys[i]
    let num = hash[key] > 1 ? ' (' + hash[key] + ' repeats)' : ''
    if (i > 0) domains.push(<span key={i + 'comma'}>, </span>)
    domains.push(
      <span key={'domainListSpan' + key} style={{ whiteSpace: 'nowrap' }}>
        {key + num}
      </span>
    )
  }
  return <div>{domains}</div>
}

function bulletList(data, item, itemArrayKey, rowIdx) {
  let bullets = []
  for (let i = 0; i < data.length; i++) {
    bullets.push(<li key={'locationsListSpan' + i}>{data[i]}</li>)
  }
  return <ul style={{ paddingLeft: 15, margin: 0 }}>{bullets}</ul>
}

function scaffold(data, item, formatExtraData, rowIdx) {
  if (data && data.length > 0) {
    return getScaffoldFromLoc(data)
  }
}

function genotype(data, item, formatExtraData, rowIdx) {
  let complist = []
  for (let i = 0; i < item.components.length; i++) {
    // let rLinkArr = reportLinkHash(item.components[i],item,'none');
    let compObj = item.components[i]
    let k = Object.keys(compObj)[0]
    if (k.match(/^FB/))
      complist.push(
        <ReportLink key={k} id={k}>
          <FlyBaseSymbol symbol={compObj[k]} />
        </ReportLink>
      )
    if (k.match(/^string/))
      complist.push(
        <span key={k + Math.random()} id={k + Math.random()}>
          <FlyBaseSymbol symbol={compObj[k]} />
        </span>
      )
  }
  return <div key="genotypes">{complist}</div>
}

function browserLinks(data, item, formatExtraData, rowIdx) {
  if (item.location || (item.locations && item.locations.length > 0)) {
    return <BrowserLinks item={item} mini={true} />
  }
}

// End Formatters

/* Column Widths
   Each TableHeaderColumn can have a width property.  It takes the usual CSS-type values; pixels, percents, ems, etc.
   The way the table responds is not exactly like a normal CSS table cell, however.
   There is no 'minWidth' or 'maxWidth' property available.  Instead, setting the width property automatically sets
   BOTH the width AND the min-width CSS property for that column (in the colgroup for the table).
   So in practice, a column with a percent width has NO minimum width.  If there are other columns set with pixels or ems,
   a percent column will squeeze to zero width at small screen sizes.  Only if ALL columns have percent widths
   is this problem avoided, but then even small but essential columns get their contents truncated.
   Conversely, setting a 'hard' column width with px or em gives it a real MINIMUM width, but not a maximum.
   Leaving the width property out of one column kills the stretching of columns set with hard widths at large screen sizes;
   instead the unset column (or columns) will soak up all the excess width.  Percent columns sharing space with unset columns
   behave as expected, expanding and contracting with screen width.
   Using a mixture of percents and hard widths works well down to fairly small screens, but not tiny ones.
   Using only hard widths can compromise the layout for wider screens, when min widths are not in good proportions for larger layouts.
   Also sets a hard lower limit on table width; table becomes horizontally scrollable below this width though.
*/

// Table components.
function FBxx({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn dataField="symbol" dataFormat={reportLink}>
        Symbol
      </TableHeaderColumn>
      <TableHeaderColumn dataField="name">Name</TableHeaderColumn>
    </BootstrapTable>
  )
}

function FBab({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="20%"
        dataField="symbol"
        dataFormat={reportLink}
        dataSort={true}>
        Symbol
      </TableHeaderColumn>
      <TableHeaderColumn
        width="40%"
        dataField="class"
        dataFormat={reportLinkHash}
        dataSort={true}
        tdStyle={{ whiteSpace: 'normal' }}
        formatExtraData="true">
        Class
      </TableHeaderColumn>
      <TableHeaderColumn
        width="30%"
        dataField="deleted_segments"
        dataFormat={segments}
        thStyle={{ whiteSpace: 'normal' }}
        tdStyle={{ whiteSpace: 'normal' }}>
        Affected Segments
      </TableHeaderColumn>
      <TableHeaderColumn
        width="60px"
        dataField="num_stocks"
        dataFormat={showRelated}
        dataSort={true}
        thStyle={{ whiteSpace: 'normal' }}
        formatExtraData="FBst">
        # Stocks
      </TableHeaderColumn>
      <TableHeaderColumn
        width="6em"
        dataField="location"
        dataFormat={browserLinks}
        thStyle={{ whiteSpace: 'normal' }}>
        Genome View
      </TableHeaderColumn>
    </BootstrapTable>
  )
}

function FBal({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="20%"
        dataField="symbol"
        dataFormat={reportLink}
        dataSort={true}
        tdStyle={{ whiteSpace: 'normal' }}>
        Symbol
      </TableHeaderColumn>
      <TableHeaderColumn
        width="15%"
        dataField="class"
        dataFormat={reportLinkHash}
        dataSort={true}
        tdStyle={{ whiteSpace: 'normal' }}>
        Class
      </TableHeaderColumn>
      <TableHeaderColumn
        width="25%"
        dataField="associated_insertions"
        dataFormat={reportLinkHash}
        tdStyle={{ whiteSpace: 'normal' }}>
        Inserted Elements
      </TableHeaderColumn>
      <TableHeaderColumn
        width="60px"
        dataField="num_stocks"
        dataFormat={showRelated}
        dataSort={true}
        thStyle={{ whiteSpace: 'normal' }}
        formatExtraData="FBst">
        # Stocks
      </TableHeaderColumn>
      <TableHeaderColumn
        width="15%"
        dataField="mutagens"
        dataFormat={expandArray}
        tdStyle={{ whiteSpace: 'normal' }}
        formatExtraData="mutagens">
        Mutagens
      </TableHeaderColumn>
      <TableHeaderColumn
        width="5em"
        dataField="known_lesion"
        dataFormat={lesion}
        dataSort={true}
        thStyle={{ whiteSpace: 'normal' }}
        formatExtraData="FBst">
        Known Lesion?
      </TableHeaderColumn>
      {/*<TableHeaderColumn width="6em"  dataField='location'              dataFormat={browserLinks}   thStyle={{whiteSpace:'normal'}} >Genome View</TableHeaderColumn>*/}
    </BootstrapTable>
  )
}

function FBba({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="30%"
        dataField="symbol"
        dataFormat={reportLink}
        dataSort={true}>
        Symbol
      </TableHeaderColumn>
      <TableHeaderColumn
        width="40%"
        dataField="short_genotype"
        dataFormat={setHTML}
        dataSort={true}
        tdStyle={{ whiteSpace: 'normal' }}>
        Short Genotype
      </TableHeaderColumn>
      <TableHeaderColumn width="5em" dataField="species_abbrev" dataSort={true}>
        Species
      </TableHeaderColumn>
      <TableHeaderColumn
        width="60px"
        dataField="num_stocks"
        dataFormat={showRelated}
        dataSort={true}
        thStyle={{ whiteSpace: 'normal' }}
        formatExtraData="FBst">
        # Stocks
      </TableHeaderColumn>
      <TableHeaderColumn
        width="50px"
        dataField="num_publications"
        dataFormat={showRelated}
        dataSort={true}
        formatExtraData="FBrf"
        thStyle={{ whiteSpace: 'normal' }}>
        # Refs
      </TableHeaderColumn>
    </BootstrapTable>
  )
}

function FBcl({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="20%"
        dataField="name"
        dataFormat={reportLink}
        dataSort={true}>
        Name
      </TableHeaderColumn>
      <TableHeaderColumn width="5em" dataField="species_abbrev" dataSort={true}>
        Species
      </TableHeaderColumn>
      <TableHeaderColumn width="8em" dataField="type" dataSort={true}>
        Type
      </TableHeaderColumn>
      <TableHeaderColumn
        width="6em"
        dataField="computed_genes"
        dataFormat={reportLinkHash}
        thStyle={{ whiteSpace: 'normal' }}>
        Computed Gene(s)
      </TableHeaderColumn>
      <TableHeaderColumn
        width="20%"
        dataField="libraries"
        dataFormat={reportLinkHash}>
        Library
      </TableHeaderColumn>
      <TableHeaderColumn
        width="10%"
        dataField="tissues"
        dataFormat={reportLinkHash}
        thStyle={{ whiteSpace: 'normal' }}>
        Tissue Source
      </TableHeaderColumn>
      <TableHeaderColumn
        width="15%"
        dataField="stages"
        dataFormat={expandArray}
        tdStyle={{ whiteSpace: 'normal' }}
        formatExtraData="stages">
        Stage(s)
      </TableHeaderColumn>
    </BootstrapTable>
  )
}

function FBco({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn dataField="symbol" dataFormat={reportLink}>
        Symbol
      </TableHeaderColumn>
      <TableHeaderColumn
        dataField="component_alleles"
        dataFormat={reportLinkArray}
        thStyle={{ whiteSpace: 'normal' }}
        tdStyle={{ whiteSpace: 'normal' }}>
        Component Alleles
      </TableHeaderColumn>
      <TableHeaderColumn
        width="60px"
        dataField="num_stocks"
        dataSort={true}
        dataFormat={showRelated}
        formatExtraData="FBst"
        thStyle={{ whiteSpace: 'normal' }}>
        # Stocks
      </TableHeaderColumn>
      <TableHeaderColumn
        width="50px"
        dataField="num_publications"
        dataSort={true}
        dataFormat={showRelated}
        formatExtraData="FBrf"
        thStyle={{ whiteSpace: 'normal' }}>
        # Refs
      </TableHeaderColumn>
      <TableHeaderColumn
        width="5em"
        dataField="expression"
        dataFormat={(_, item) => (
          <CheckCircle isChecked={item?.expression === '1'} />
        )}
        tdStyle={{ textAlign: 'center', verticalAlign: 'middle' }}
        thStyle={{ whiteSpace: 'normal', textAlign: 'center' }}>
        Expression Data
      </TableHeaderColumn>
      <TableHeaderColumn
        width="5em"
        dataField="images"
        dataFormat={(_, item) => (
          <CheckCircle isChecked={item?.images === '1'} />
        )}
        tdStyle={{ textAlign: 'center', verticalAlign: 'middle' }}
        thStyle={{ whiteSpace: 'normal', textAlign: 'center' }}>
        Image(s)
      </TableHeaderColumn>
    </BootstrapTable>
  )
}

function FBgg({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="25%"
        dataField="name"
        dataFormat={reportLink}
        dataSort={true}>
        Name
      </TableHeaderColumn>
      <TableHeaderColumn
        width="6em"
        dataField="symbol"
        dataFormat={reportLink}
        dataSort={true}>
        Symbol
      </TableHeaderColumn>
      <TableHeaderColumn
        width="6em"
        dataField="num_members"
        dataSort={true}
        thStyle={{ whiteSpace: 'normal' }}>
        # of Members
      </TableHeaderColumn>
      <TableHeaderColumn
        width="25%"
        dataField="parents"
        dataFormat={nameIDList}
        tdStyle={{ whiteSpace: 'normal' }}>
        Parent Group(s)
      </TableHeaderColumn>
      <TableHeaderColumn
        width="30%"
        dataField="components"
        dataFormat={nameIDList}
        tdStyle={{ whiteSpace: 'normal' }}>
        Componenent Group(s)
      </TableHeaderColumn>
    </BootstrapTable>
  )
}
/*
 */

function FBgn({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="6em"
        dataField="symbol"
        dataFormat={reportLink}
        dataSort={true}
        tdStyle={{ whiteSpace: 'normal' }}>
        Symbol
      </TableHeaderColumn>
      <TableHeaderColumn
        width="8em"
        dataField="name"
        dataFormat={setHTML}
        dataSort={true}
        tdStyle={{ whiteSpace: 'normal' }}>
        Name
      </TableHeaderColumn>
      <TableHeaderColumn
        width="6em"
        dataField="annotation_id"
        dataSort={true}
        thStyle={{ whiteSpace: 'normal' }}>
        Annotation ID
      </TableHeaderColumn>
      <TableHeaderColumn
        width="7em"
        dataField="cytology"
        dataSort={true}
        tdStyle={{ wordWrap: 'break-word' }}>
        Cytology
      </TableHeaderColumn>
      <TableHeaderColumn
        width="5em"
        dataField="location"
        dataFormat={scaffold}
        dataSort={true}
        tdStyle={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
        Scaffold
      </TableHeaderColumn>
      <TableHeaderColumn
        width="60px"
        dataField="num_alleles"
        dataFormat={showRelated}
        formatExtraData="FBal"
        dataSort={true}
        thStyle={{ whiteSpace: 'normal' }}>
        # Alleles
      </TableHeaderColumn>
      <TableHeaderColumn
        width="60px"
        dataField="num_stocks"
        dataFormat={showRelated}
        formatExtraData="FBst"
        dataSort={true}
        thStyle={{ whiteSpace: 'normal' }}>
        # Stocks
      </TableHeaderColumn>
      <TableHeaderColumn
        width="50px"
        dataField="num_publications"
        dataFormat={showRelated}
        formatExtraData="FBrf"
        dataSort={true}
        thStyle={{ whiteSpace: 'normal' }}>
        # Refs
      </TableHeaderColumn>
      <TableHeaderColumn
        width="6em"
        dataField="location"
        dataFormat={browserLinks}
        thStyle={{ whiteSpace: 'normal' }}>
        Genome View
      </TableHeaderColumn>
    </BootstrapTable>
  )
}

function FBhh({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="12em"
        dataField="name"
        tdStyle={{ whiteSpace: 'normal' }}
        dataFormat={reportLink}
        dataSort={true}>
        Name
      </TableHeaderColumn>
      <TableHeaderColumn
        width="9em"
        dataField="do"
        thStyle={{ whiteSpace: 'normal' }}
        dataFormat={reportLinkHash}
        dataSort={true}
        tdStyle={{ whiteSpace: 'normal' }}
        formatExtraData="name">
        DO Term
      </TableHeaderColumn>
      <TableHeaderColumn
        width="60px"
        dataField="omim"
        thStyle={{ whiteSpace: 'normal' }}
        dataFormat={linkOMIM}
        dataSort={true}
        formatExtraData="accession">
        OMIM ID
      </TableHeaderColumn>
      <TableHeaderColumn
        width="75px"
        dataField="genes"
        thStyle={{ whiteSpace: 'normal' }}
        dataFormat={reportLinkHash}>
        <i>D.&nbsp;melanogaster</i> gene
      </TableHeaderColumn>
      <TableHeaderColumn
        width="7em"
        dataField="transgenes"
        thStyle={{ whiteSpace: 'normal' }}
        dataFormat={reportLinkHash}
        dataSort={true}
        tdStyle={{ whiteSpace: 'normal' }}>
        Transgene in&nbsp;Fly (human or&nbsp;other)
      </TableHeaderColumn>
      <TableHeaderColumn
        width="6em"
        dataField="hgnc"
        thStyle={{ whiteSpace: 'normal' }}
        dataFormat={linksHGNC}
        dataSort={true}
        tdStyle={{ whiteSpace: 'normal' }}>
        Human Genes Implicated (HGNC)
      </TableHeaderColumn>
      <TableHeaderColumn
        width="75px"
        dataField="num_subtypes"
        thStyle={{ whiteSpace: 'normal' }}
        dataFormat={showRelated}
        formatExtraData="FBhh?qualifier=subtype"
        dataSort={true}>
        # Subtype Group Members
      </TableHeaderColumn>
      <TableHeaderColumn
        width="75px"
        dataField="num_related"
        thStyle={{ whiteSpace: 'normal' }}
        dataFormat={showRelated}
        formatExtraData="FBhh?qualifier=associated_with"
        dataSort={true}>
        # Related Disease Terms
      </TableHeaderColumn>
      <TableHeaderColumn
        width="50px"
        dataField="num_publications"
        thStyle={{ whiteSpace: 'normal' }}
        dataFormat={showRelated}
        dataSort={true}
        formatExtraData="FBrf">
        # Refs
      </TableHeaderColumn>
    </BootstrapTable>
  )
}

function FBig({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="25%"
        dataField="genes"
        dataFormat={reportLinkHash2Text}
        thStyle={{ whiteSpace: 'normal' }}>
        Interacting Genes
      </TableHeaderColumn>
      <TableHeaderColumn
        width="30%"
        dataField="types"
        dataFormat={expandArray}
        tdStyle={{ whiteSpace: 'normal' }}
        formatExtraData="types">
        Type(s)
      </TableHeaderColumn>
      <TableHeaderColumn
        width="40%"
        dataField="descriptions"
        dataFormat={expandArray}
        tdStyle={{ whiteSpace: 'normal' }}
        formatExtraData="descriptions">
        Description(s)
      </TableHeaderColumn>
      <TableHeaderColumn
        width="55px"
        dataField="num_interactions"
        dataSort={true}
        thStyle={{ whiteSpace: 'normal' }}
        tdStyle={{ textAlign: 'center' }}>
        # of Experiments
      </TableHeaderColumn>
      <TableHeaderColumn
        width="50px"
        dataField="num_publications"
        dataSort={true}
        dataFormat={showRelated}
        formatExtraData="FBrf"
        thStyle={{ whiteSpace: 'normal' }}>
        # Refs
      </TableHeaderColumn>
    </BootstrapTable>
  )
}

function FBim({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="107px"
        dataField="thumbnail"
        dataFormat={imageLink}>
        Image
      </TableHeaderColumn>
      <TableHeaderColumn
        dataField="caption"
        dataFormat={getImageDescription}
        tdStyle={{ whiteSpace: 'normal' }}>
        Short Description
      </TableHeaderColumn>
      <TableHeaderColumn
        width="10%"
        dataField="num_anatomy"
        dataFormat={showRelated}
        dataSort={true}
        formatExtraData="FBbt"
        thStyle={{ whiteSpace: 'normal', textAlign: 'center' }}
        tdStyle={{ textAlign: 'center' }}>
        # Anatomy Terms
      </TableHeaderColumn>
      <TableHeaderColumn
        width="10%"
        dataField="num_stage"
        dataFormat={showRelated}
        dataSort={true}
        formatExtraData="FBdv"
        thStyle={{ whiteSpace: 'normal', textAlign: 'center' }}
        tdStyle={{ textAlign: 'center' }}>
        # Stage Terms
      </TableHeaderColumn>
      <TableHeaderColumn
        width="10%"
        dataField="num_biological_process"
        dataFormat={showRelated}
        dataSort={true}
        formatExtraData="GO"
        thStyle={{ whiteSpace: 'normal', textAlign: 'center' }}
        tdStyle={{ textAlign: 'center' }}>
        # Process Terms
      </TableHeaderColumn>
    </BootstrapTable>
  )
}
//      <TableHeaderColumn               dataField='caption' tdStyle={{whiteSpace:'normal'}}>Caption</TableHeaderColumn>

function FBlc({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="150px"
        dataField="symbol"
        dataFormat={reportLink}
        dataSort={true}
        tdStyle={{ whiteSpace: 'normal' }}>
        Symbol
      </TableHeaderColumn>
      <TableHeaderColumn width="8em" dataField="class" dataSort={true}>
        Class
      </TableHeaderColumn>
      <TableHeaderColumn
        width="6em"
        dataField="type"
        dataFormat={reportLinkHash}
        dataSort={true}
        tdStyle={{ whiteSpace: 'normal' }}>
        Type
      </TableHeaderColumn>
      <TableHeaderColumn
        width="9em"
        dataField="title"
        dataFormat={setHTML}
        dataSort={true}>
        Title
      </TableHeaderColumn>
      <TableHeaderColumn width="4em" dataField="species_abbrev" dataSort={true}>
        Species
      </TableHeaderColumn>
    </BootstrapTable>
  )
}

function FBpp({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="150px"
        dataField="symbol"
        dataFormat={reportLink}
        dataSort={true}>
        Symbol
      </TableHeaderColumn>
      <TableHeaderColumn
        width="5em"
        dataField="length"
        dataSort={true}
        thStyle={{ whiteSpace: 'normal' }}>
        Length (aa)
      </TableHeaderColumn>
      <TableHeaderColumn
        width="6em"
        dataField="predicted_mw"
        dataSort={true}
        thStyle={{ whiteSpace: 'normal' }}>
        Predicted MW
      </TableHeaderColumn>
      <TableHeaderColumn
        width="200px"
        dataField="domains"
        dataFormat={domainListUnique}
        tdStyle={{ whiteSpace: 'normal' }}
        formatExtraData="domains">
        Domains
      </TableHeaderColumn>
      <TableHeaderColumn
        width="50px"
        dataField="num_publications"
        dataFormat={showRelated}
        dataSort={true}
        formatExtraData="FBrf"
        thStyle={{ whiteSpace: 'normal' }}>
        # Refs
      </TableHeaderColumn>
      <TableHeaderColumn
        width="6em"
        dataField="location"
        dataFormat={browserLinks}
        thStyle={{ whiteSpace: 'normal' }}>
        Genome View
      </TableHeaderColumn>
    </BootstrapTable>
  )
}

function FBrf({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="6em"
        dataField="authors"
        tdStyle={{ whiteSpace: 'normal' }}
        dataSort={true}
        dataFormat={reportLink}>
        Authors
      </TableHeaderColumn>
      <TableHeaderColumn width="4em" dataField="year" dataSort={true}>
        Year
      </TableHeaderColumn>
      <TableHeaderColumn
        width="30%"
        dataField="title"
        dataSort={true}
        dataFormat={setHTML}
        tdStyle={{ whiteSpace: 'normal' }}>
        Title
      </TableHeaderColumn>
      <TableHeaderColumn
        width="6em"
        dataField="journal"
        dataSort={true}
        tdStyle={{ whiteSpace: 'normal' }}>
        Journal
      </TableHeaderColumn>
      <TableHeaderColumn width="3em" dataField="volume" dataSort={true}>
        Vol
      </TableHeaderColumn>
      <TableHeaderColumn width="85px" dataField="pages">
        Pages
      </TableHeaderColumn>
      <TableHeaderColumn
        width="6em"
        dataField="type"
        dataSort={true}
        tdStyle={{ whiteSpace: 'normal' }}
        thStyle={{ whiteSpace: 'normal' }}>
        Pub Type
      </TableHeaderColumn>
    </BootstrapTable>
  )
}

function FBsf({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="30%"
        dataField="symbol"
        dataSort={true}
        dataFormat={reportLink}>
        Symbol
      </TableHeaderColumn>
      <TableHeaderColumn
        width="25%"
        dataField="type"
        dataSort={true}
        dataFormat={removeUnderscores}
        formatExtraData="type">
        Type
      </TableHeaderColumn>
      <TableHeaderColumn
        width="60px"
        dataField="associated_genes"
        dataFormat={reportLinkHash}
        thStyle={{ whiteSpace: 'normal' }}>
        Assoc. Genes
      </TableHeaderColumn>
      <TableHeaderColumn
        width="30%"
        dataField="associated_datasets"
        dataFormat={reportLinkHash}
        tdStyle={{ whiteSpace: 'normal' }}>
        Datasets/Collections
      </TableHeaderColumn>
    </BootstrapTable>
  )
}

function FBsn({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="30%"
        dataField="symbol"
        dataSort={true}
        dataFormat={reportLink}>
        Symbol
      </TableHeaderColumn>
      <TableHeaderColumn
        width="50%"
        dataField="name"
        dataSort={true}
        tdStyle={{ whiteSpace: 'normal' }}>
        Name
      </TableHeaderColumn>
      <TableHeaderColumn width="5em" dataField="species_abbrev" dataSort={true}>
        Species
      </TableHeaderColumn>
      <TableHeaderColumn
        width="60px"
        dataField="num_stocks"
        dataSort={true}
        dataFormat={showRelated}
        formatExtraData="FBst"
        thStyle={{ whiteSpace: 'normal' }}>
        # Stocks
      </TableHeaderColumn>
      <TableHeaderColumn
        width="50px"
        dataField="num_publications"
        dataSort={true}
        dataFormat={showRelated}
        formatExtraData="FBrf"
        thStyle={{ whiteSpace: 'normal' }}>
        # Refs
      </TableHeaderColumn>
    </BootstrapTable>
  )
}

function FBst({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="120px"
        dataField="id"
        dataSort={true}
        dataFormat={reportLink}>
        FlyBase Report
      </TableHeaderColumn>
      <TableHeaderColumn
        width="25%"
        dataField="collection"
        dataSort={true}
        tdStyle={{ whiteSpace: 'normal' }}>
        Collection
      </TableHeaderColumn>
      <TableHeaderColumn
        width="70px"
        dataField="stock_num"
        dataSort={true}
        dataFormat={stockExternalLink}
        tdStyle={{ wordWrap: 'break-word', whiteSpace: 'normal' }}
        thStyle={{ whiteSpace: 'normal' }}>
        Stock #
      </TableHeaderColumn>
      <TableHeaderColumn
        width="40%"
        dataField="genotype"
        dataSort={true}
        dataFormat={genotype}
        tdStyle={{ whiteSpace: 'normal' }}>
        Genotype
      </TableHeaderColumn>
      <TableHeaderColumn width="5em" dataField="species_abbrev" dataSort={true}>
        Species
      </TableHeaderColumn>
    </BootstrapTable>
  )
}

function FBtc({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="25%"
        dataField="symbol"
        dataSort={true}
        dataFormat={reportLink}>
        Symbol
      </TableHeaderColumn>
      <TableHeaderColumn width="5em" dataField="species_abbrev" dataSort={true}>
        Species
      </TableHeaderColumn>
      <TableHeaderColumn
        width="20%"
        dataField="source_strains"
        thStyle={{ whiteSpace: 'normal' }}>
        Source Strain
      </TableHeaderColumn>
      <TableHeaderColumn
        width="20%"
        dataField="tissue_sources"
        dataFormat={reportLinkHash}
        thStyle={{ whiteSpace: 'normal' }}>
        Tissue Source(s)
      </TableHeaderColumn>
      <TableHeaderColumn
        width="20%"
        dataField="developmental_stages"
        dataFormat={reportLinkHash}
        thStyle={{ whiteSpace: 'normal' }}>
        Dev. Stage(s)
      </TableHeaderColumn>
      <TableHeaderColumn
        width="5em"
        dataField="dgrc_stock"
        dataSort={true}
        thStyle={{ whiteSpace: 'normal' }}>
        DGRC Stock
      </TableHeaderColumn>
    </BootstrapTable>
  )
}

function FBte({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="20%"
        dataField="symbol"
        dataSort={true}
        dataFormat={reportLink}>
        Symbol
      </TableHeaderColumn>
      <TableHeaderColumn
        width="50px"
        dataField="species_abbrev"
        dataSort={true}>
        Species
      </TableHeaderColumn>
      <TableHeaderColumn
        width="8em"
        dataField="size"
        dataSort={true}
        dataFormat={expandArray}
        formatExtraData="size"
        tdStyle={{ whiteSpace: 'normal' }}
        thStyle={{ whiteSpace: 'normal' }}>
        Size
      </TableHeaderColumn>
      <TableHeaderColumn
        width="30%"
        dataField="copy_number"
        dataSort={true}
        dataFormat={bulletList}
        tdStyle={{ whiteSpace: 'normal' }}
        thStyle={{ whiteSpace: 'normal' }}>
        Copy # In Sequenced Strain
      </TableHeaderColumn>
      <TableHeaderColumn
        width="50px"
        dataField="num_accessions"
        dataSort={true}
        dataFormat={showRelated}
        formatExtraData="FB??"
        thStyle={{ whiteSpace: 'normal' }}>
        # Accessions
      </TableHeaderColumn>
      <TableHeaderColumn
        width="50px"
        dataField="num_publications"
        dataSort={true}
        dataFormat={showRelated}
        formatExtraData="FBrf"
        thStyle={{ whiteSpace: 'normal' }}>
        # Refs
      </TableHeaderColumn>
    </BootstrapTable>
  )
}

function FBti({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="40%"
        dataField="symbol"
        dataSort={true}
        dataFormat={reportLink}>
        Symbol
      </TableHeaderColumn>
      <TableHeaderColumn width="3em" dataField="chromosome" dataSort={true}>
        Arm
      </TableHeaderColumn>
      <TableHeaderColumn
        width="8em"
        dataField="cytology"
        dataSort={true}
        tdStyle={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
        Cytology
      </TableHeaderColumn>
      <TableHeaderColumn
        width="60px"
        dataField="num_stocks"
        dataSort={true}
        dataFormat={showRelated}
        formatExtraData="FBst"
        thStyle={{ whiteSpace: 'normal' }}>
        # Stocks
      </TableHeaderColumn>
      <TableHeaderColumn
        width="60px"
        dataField="num_alleles"
        dataSort={true}
        dataFormat={showRelated}
        formatExtraData="FBal"
        thStyle={{ whiteSpace: 'normal' }}>
        Assoc. Alleles
      </TableHeaderColumn>
      <TableHeaderColumn
        width="6em"
        dataField="locations"
        dataFormat={browserLinks}
        thStyle={{ whiteSpace: 'normal' }}>
        Genome View
      </TableHeaderColumn>
    </BootstrapTable>
  )
}

function FBto({ items, store, ...props }) {
  //<TableHeaderColumn width="3em"  dataField='num_insertions'                       dataSort={true} dataFormat={showRelated} formatExtraData="FBti" thStyle={{whiteSpace:'normal',overflowWrap:'break-word'}}># Insertions</TableHeaderColumn>
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        row="0"
        rowSpan="2"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="15%"
        row="0"
        rowSpan="2"
        dataField="symbol"
        dataSort={true}
        dataFormat={reportLink}>
        Symbol
      </TableHeaderColumn>
      <TableHeaderColumn
        width="25%"
        row="0"
        rowSpan="2"
        dataField="uses"
        dataFormat={reportLinkHash}
        tdStyle={{ whiteSpace: 'normal' }}>
        Uses
      </TableHeaderColumn>
      <TableHeaderColumn
        width="32px"
        row="0"
        rowSpan="2"
        dataField="num_alleles"
        dataSort={true}
        dataFormat={showRelated}
        formatExtraData="FBal"
        thStyle={{ whiteSpace: 'normal', overflowWrap: 'break-word' }}>
        # Alleles
      </TableHeaderColumn>
      <TableHeaderColumn
        width="3em"
        row="0"
        rowSpan="2"
        dataField="num_constructs"
        dataSort={true}
        dataFormat={showRelated}
        formatExtraData="FBtp"
        thStyle={{ whiteSpace: 'normal', overflowWrap: 'break-word' }}>
        # Constructs
      </TableHeaderColumn>
      <TableHeaderColumn
        row="0"
        colSpan="3"
        thStyle={{
          whiteSpace: 'normal',
          overflowWrap: 'break-word',
          textAlign: 'center',
        }}>
        # Associated Tools
      </TableHeaderColumn>
      <TableHeaderColumn
        width="3em"
        row="1"
        dataField="num_compatible_tools"
        dataSort={true}
        dataFormat={showRelated}
        formatExtraData="FBto?qualifier=compatible_tool"
        thStyle={{ whiteSpace: 'normal', overflowWrap: 'break-word' }}>
        Compatible
      </TableHeaderColumn>
      <TableHeaderColumn
        width="3em"
        row="1"
        dataField="num_common_gene_origin_related_tools"
        dataSort={true}
        dataFormat={showRelated}
        formatExtraData="FBto?qualifier=originates_from"
        thStyle={{ whiteSpace: 'normal' }}>
        Related (Gene of Origin)
      </TableHeaderColumn>
      <TableHeaderColumn
        width="3em"
        row="1"
        dataField="num_other_related_tools"
        dataSort={true}
        dataFormat={showRelated}
        formatExtraData="FBto?qualifier=related_tool"
        thStyle={{ whiteSpace: 'normal' }}>
        Other Related
      </TableHeaderColumn>
    </BootstrapTable>
  )
}

function FBtp({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="30%"
        dataField="symbol"
        dataSort={true}
        dataFormat={reportLink}>
        Symbol
      </TableHeaderColumn>
      <TableHeaderColumn
        width="30%"
        dataField="associated_alleles"
        dataFormat={reportLinkHash}
        thStyle={{ whiteSpace: 'normal' }}>
        Associated Alleles
      </TableHeaderColumn>
      <TableHeaderColumn
        width="6em"
        dataField="num_insertions"
        dataSort={true}
        dataFormat={showRelated}
        formatExtraData="FBti"
        thStyle={{ whiteSpace: 'normal' }}>
        Associated Insertions
      </TableHeaderColumn>
      <TableHeaderColumn
        width="60px"
        dataField="num_stocks"
        dataSort={true}
        dataFormat={showRelated}
        formatExtraData="FBst"
        thStyle={{ whiteSpace: 'normal' }}>
        # Stocks
      </TableHeaderColumn>
      <TableHeaderColumn
        width="50px"
        dataField="num_publications"
        dataSort={true}
        dataFormat={showRelated}
        formatExtraData="FBrf"
        thStyle={{ whiteSpace: 'normal' }}>
        # Refs
      </TableHeaderColumn>
      <TableHeaderColumn
        width="4em"
        dataField="expression"
        dataFormat={(_, item) => (
          <CheckCircle isChecked={item?.expression === '1'} />
        )}
        tdStyle={{ textAlign: 'center', verticalAlign: 'middle' }}
        thStyle={{ whiteSpace: 'normal' }}>
        Expression Data
      </TableHeaderColumn>
      <TableHeaderColumn
        width="4em"
        dataField="images"
        dataFormat={(_, item) => (
          <CheckCircle isChecked={item?.images === '1'} />
        )}
        tdStyle={{ textAlign: 'center', verticalAlign: 'middle' }}
        thStyle={{ whiteSpace: 'normal' }}>
        Image(s)
      </TableHeaderColumn>
    </BootstrapTable>
  )
}

function FBtr({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="25%"
        dataField="symbol"
        dataSort={true}
        dataFormat={reportLink}>
        Symbol
      </TableHeaderColumn>
      <TableHeaderColumn width="7em" dataField="type" dataSort={true}>
        Feature type
      </TableHeaderColumn>
      <TableHeaderColumn
        width="5em"
        dataField="length"
        dataSort={true}
        thStyle={{ whiteSpace: 'normal' }}>
        Length (nt)
      </TableHeaderColumn>
      <TableHeaderColumn width="5em" dataField="cds_length" dataSort={true}>
        Associated
        <br />
        CDS (aa)
      </TableHeaderColumn>
      <TableHeaderColumn
        width="5em"
        dataField="num_clones"
        dataSort={true}
        dataFormat={showRelated}
        formatExtraData="FBcl">
        Supporting
        <br />
        Clones
      </TableHeaderColumn>
      <TableHeaderColumn
        width="6em"
        dataField="location"
        dataFormat={browserLinks}
        thStyle={{ whiteSpace: 'normal' }}>
        Genome View
      </TableHeaderColumn>
    </BootstrapTable>
  )
}
//       <TableHeaderColumn width="50px" dataField='num_publications'   dataFormat={showRelated}    formatExtraData="FBrf" thStyle={{whiteSpace:'normal'}}># Refs</TableHeaderColumn>

function CVterm({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="30%"
        dataField="name"
        dataSort={true}
        tdStyle={{ whiteSpace: 'normal' }}
        dataFormat={reportLink}>
        Name
      </TableHeaderColumn>
      <TableHeaderColumn
        dataField="definition"
        dataSort={true}
        tdStyle={{ whiteSpace: 'normal' }}>
        Definition
      </TableHeaderColumn>
    </BootstrapTable>
  )
}

/**
 *
 * TODO Jim - Implement table view for FBch
 *
 * Example FBch item attributes:
 *  {
 *    "num_publications" : 4,
 *    "name" : "α-terpinene",
 *    "score" : null,
 *    "definition" : "ChEBI: Alpha-terpinene is one of three isomeric monoterpenes differing in the positions of
 *    their two double bonds (beta- and gamma-terpinene being the others). In alpha-terpinene the double bonds are at
 *    the 1- and 3-positions of the p-menthane skeleton. It has a role as a volatile oil component and a plant
 *    metabolite. It is a monoterpene and a cyclohexadiene.",
 *    "data_type" : "FBch",
 *    "update_status" : null,
 *    "pubchem" : "7462",
 *    "chebi" : "CHEBI:10334",
 *    "id" : "FBch0000219"
 *  }
 *
 * @param items {array} - FBch items.
 * @param store {object} - MOBX HitList store.
 * @param props - Other props passd in.
 * @returns {JSX.Element}
 */
function FBch({ items, store, ...props }) {
  return (
    <BootstrapTable data={items} {...props}>
      <TableHeaderColumn
        width="25px"
        dataField="id"
        dataFormat={checkbox}
        formatExtraData={{ store: store }}>
        {props.toggleAll}
      </TableHeaderColumn>
      <TableHeaderColumn
        width="5em"
        dataField="name"
        tdStyle={{ whiteSpace: 'normal' }}
        dataFormat={reportLink}
        dataSort={true}>
        Name
      </TableHeaderColumn>
      <TableHeaderColumn
        width="9em"
        dataField="roles"
        thStyle={{ whiteSpace: 'normal' }}
        dataFormat={nameIDList}
        dataSort={false}
        tdStyle={{ whiteSpace: 'normal' }}>
        ChEBI Application and Biological Roles
      </TableHeaderColumn>
      <TableHeaderColumn
        width="50px"
        dataField="num_publications"
        thStyle={{ whiteSpace: 'normal' }}
        dataFormat={showRelated}
        dataSort={true}
        formatExtraData="FBrf">
        # Refs
      </TableHeaderColumn>
    </BootstrapTable>
  )
}

function Compact(props) {
  const { store } = props
  const dataClassLabels = store.itemStore.dataClassLabels

  const data_type =
    props.items.length > 0 ? typeFromId(props.items[0].id) : null

  function onSortChange(sortName, sortOrder) {
    store.setSort(sortName, sortOrder)
  }

  let Table = FBxx

  switch (data_type) {
    case 'FBab':
      Table = FBab
      break
    case 'FBal':
      Table = FBal
      break
    case 'FBba':
      Table = FBba
      break
    case 'FBch':
      Table = FBch
      break
    case 'FBcl':
      Table = FBcl
      break
    case 'FBco':
      Table = FBco
      break
    case 'FBgg':
      Table = FBgg
      break
    case 'FBgn':
      Table = FBgn
      break
    case 'FBhh':
      Table = FBhh
      break
    case 'FBig':
      Table = FBig
      break
    case 'FBim':
      Table = FBim
      break
    case 'FBlc':
      Table = FBlc
      break
    case 'FBpp':
      Table = FBpp
      break
    case 'FBrf':
      Table = FBrf
      break
    case 'FBsf':
      Table = FBsf
      break
    case 'FBsn':
      Table = FBsn
      break
    case 'FBst':
      Table = FBst
      break
    case 'FBtc':
      Table = FBtc
      break
    case 'FBte':
      Table = FBte
      break
    case 'FBti':
      Table = FBti
      break
    case 'FBmc':
    case 'FBms':
    case 'FBtp':
      Table = FBtp
      break
    case 'FBto':
      Table = FBto
      break
    case 'FBtr':
      Table = FBtr
      break
    case 'FBcv':
    case 'FBsv':
    case 'FBdv':
    case 'FBbt':
    case 'FBmi':
    case 'DOID':
    case 'MI':
    case 'GO':
    case 'SO':
    case 'CHEBI':
      Table = CVterm
      break
    default:
      Table = FBxx
      break
  }
  Table = observer(Table)

  const items = toJS(props.items)

  const toggleAll = (
    <ToggleAll
      mode={store.selectedMode}
      onDeSelect={() => store.deSelectAllFiltered()}
      onSelect={() => store.selectAllFiltered()}
    />
  )

  const options = {
    onSortChange: onSortChange,
    sortName: store.sortName,
    sortOrder: store.sortOrder,
  }

  return (
    <Table
      striped={true}
      hover={true}
      condensed={true}
      keyField="id"
      dataClassLabels={dataClassLabels}
      items={items}
      toggleAll={toggleAll}
      remote={true}
      options={options}
      {...props}
    />
  )
}

Compact.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  store: PropTypes.object,
}

export default observer(Compact)
